import { render, staticRenderFns } from "./PanelNinos.vue?vue&type=template&id=6a9971c2&scoped=true"
import script from "./PanelNinos.vue?vue&type=script&lang=js"
export * from "./PanelNinos.vue?vue&type=script&lang=js"
import style0 from "./PanelNinos.vue?vue&type=style&index=0&id=6a9971c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9971c2",
  null
  
)

export default component.exports